export const food_logo1 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/" ;
export const logo_img1 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeZQ6I-CkEkeiLV7gXaWfIpP8q1ShpVXVCrg&usqp=CAU";
